/**
 * HOW TO USED IT
 *  import COLORS from '@dkrm/general-libs/theme/colors';
 *  ...
 *  const fontColor : COLORS.SECONDARY
 *
 *
 */

export default {
  /**
   * Color Constants - Sync with Web Version
   */
  C_PRIMARY: '#008489',
  C_PRIMARY_ACTIVE: '#17868C',
  C_PRIMARY_FOCUS: '#56D2D9',
  C_PRIMARY_LIGHT: '#AAE6E9',
  C_SECONDARY: '#ff5a5f',
  C_SECONDARY_ACTIVE: '#e00007',
  C_SECONDARY_FOCUS: '#ff7e82',
  C_SECONDARY_LIGHT: '#FFC9CB',
  C_DEFAULT: '#c4c4c4',
  C_DEFAULT_ACTIVE: '#565a5c',
  C_DEFAULT_LIGHT: '#E8E8E8',
  C_MUTED: '#82888a',
  C_LIGHT_GREY: '#cacccd',
  C_BEACH: '#ffb400',
  C_LIMA: '#3fb34f',
  C_URA: '#2b6dad',
  C_PANEL_DARK: '#edefed',
  C_PANEL_LIGHT: '#f5f5f5',
  C_MEDIUM_LIGHT: '#dce0e0',
  C_DARK: '#484848',
  C_BACKDROP: 'rgba(216,216,216, 0.5)',
  /**
   * Color Constants - Apps Version (Deprecated)
   */
  SECONDARY: '#00b1bb',
  SECONDARY_ACTIVE: '#17868C',
  SECONDARY_HIGHLIGHT: '#05F0FB',
  SECONDARY_DISABLED: '#7CD5DA',
  SECONDARY_DARK: '#008389',
  MUTED: '#ccc',
  LIGHT_GRAY: '#F5F5F5',
  /**
   * Color Constants - Apps Version
   */
  BRAND: '#fff',
  STATUSBAR: 'black',
  BRAND_TEXT: '#333',
  SECONDARY_TEXT: '#fff',
  INACTIVE_TEXT: '#aaaaaa',
  PLACEHOLDER: '#A7A7A7',
  RED: '#f33',
  GOLD: '#B9B87A',
  MAROON: '#B0332B',
  DARK_RED: '#C70000',
  GRAY_BACKGROUND: '#F7F7F7',
  WHITE: '#FFFFFF',
  GRAY: '#EEEEEE',
  GRAY_TEXT: '#555555',
  GRAY_BORDER: '#f0f0f0',
  PASTEL_GRAY: '#bfbfbf',
  DARK_GRAY: '#484848',
  ALMOST_BLACK: '#3c3c3c',
  BLACK: '#000',
  SEMI_MUTED: '#666',
  CANVAS: '#FFF',
  RIPPLE_LIGHT: 'rgba(255,255,255,0.15)',
  RIPPLE_DARK: 'rgba(0,0,0,0.15)',
  DARK_OVERLAY: 'rgba(0,0,0,0.3)',
  TRANSPARENT: 'rgba(0,0,0,0)',
  GRID: '#E8E8E8',
  SECONDARY_LISTVIEW: '#A8A8AF',
  SELECTED_BACKGROUND: '#F2F9FC',
  SELECTED_BORDER: '#DCEFF7',
  FACEBOOK: '#3b5998',
  // Color Scheme
  SCHEME_GRAY: '#F1F4F7',
  SCHEME_GRAY_DARK: '#DEE2E5',
  SCHEME_GRAY_TEXT: '#333333',
  SCHEME_YELLOW: '#FFF7E2',
  SCHEME_YELLOW_DARK: '#E6B138',
  SCHEME_YELLOW_TEXT: '#8B6F32',
  SCHEME_RED: '#F2DEDE',
  SCHEME_RED_TEXT: '#A94442',
  SCHEME_GREEN: '#DFF0D8',
  SCHEME_GREEN_TEXT: '#3C763D',
  // HTML specific
  LINK: '#3399ff'
};